var map = {
	"./1.png": "a205",
	"./2.png": "a2056",
	"./3.png": "a20566",
	"./4.png": "a20566a",
	"./5.png": "a20566a2",
	"./6.png": "a20566a21",
	"./7.png": "a20566a21e",
	"./8.png": "a20566a21e4",
	"./9.png": "a20566a21e44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d30e";